"use client";
import * as React from "react";

type IconProps = {
  className?: string;
  size?: number | string;
  filled?: boolean;
};

function svgProps({ className, size }: IconProps) {
  const s = size ?? 24;
  return {
    className,
    width: typeof s === 'number' ? s : s,
    height: typeof s === 'number' ? s : s,
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
  } as const;
}

export function BrandBell({ className, size }: IconProps) {
  return (
    <svg {...svgProps({ className, size })} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M15 18H9a5 5 0 0 1-5-5v-1a7 7 0 1 1 14 0v1a5 5 0 0 1-5 5Z" />
      <path d="M9.5 18a2.5 2.5 0 0 0 5 0" />
    </svg>
  );
}

export function BrandHeart({ className, size, filled }: IconProps) {
  if (filled) {
    return (
      <svg {...svgProps({ className, size })} fill="currentColor">
        <path d="M12 21s-6.5-4.35-9.1-7.2C.2 11.1 1.1 7.6 3.9 6.2 6 5.1 8.5 5.7 10 7.3L12 9.4l2-2.1c1.5-1.6 4-2.2 6.1-1.1 2.8 1.4 3.7 4.9 1 7.6C18.5 16.7 12 21 12 21Z" />
      </svg>
    );
  }
  return (
    <svg {...svgProps({ className, size })} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.8 8.5c0 4.2-8.8 10-8.8 10S3.2 12.7 3.2 8.5A4.3 4.3 0 0 1 7.5 4.2c1.6 0 3 .8 3.8 2.1A4.4 4.4 0 0 1 19 4.2a4.3 4.3 0 0 1 1.8 4.3Z" />
    </svg>
  );
}

export function BrandPlay({ className, size }: IconProps) {
  return (
    <svg {...svgProps({ className, size })} fill="currentColor">
      <path d="M7 5.5v13l11-6.5-11-6.5Z" />
    </svg>
  );
}

export function BrandSend({ className, size }: IconProps) {
  return (
    <svg {...svgProps({ className, size })} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 3L9 15" />
      <path d="M21 3l-7 18-3-8-8-3 18-7Z" />
    </svg>
  );
}

export function BrandImage({ className, size }: IconProps) {
  return (
    <svg {...svgProps({ className, size })} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M8 13l2.5-2.5L14 14l2-2 3 3" />
      <circle cx="8" cy="9" r="1.5" />
    </svg>
  );
}

export function BrandEmoji({ className, size }: IconProps) {
  return (
    <svg {...svgProps({ className, size })} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <path d="M8.5 10.5h.01M15.5 10.5h.01" />
      <path d="M8.5 14a4.5 4.5 0 0 0 7 0" />
    </svg>
  );
}

export function BrandComment({ className, size }: IconProps) {
  return (
    <svg {...svgProps({ className, size })} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 15a3 3 0 0 1-3 3H9l-4 3v-3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v8Z" />
    </svg>
  );
}

export function BrandSearch({ className, size }: IconProps) {
  return (
    <svg {...svgProps({ className, size })} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="10.5" cy="10.5" r="6" />
      <path d="M16 16l4 4" />
    </svg>
  );
}

export function BrandList({ className, size }: IconProps) {
  return (
    <svg {...svgProps({ className, size })} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 7h12M6 12h12M6 17h12" />
    </svg>
  );
}

export function BrandLogin({ className, size }: IconProps) {
  return (
    <svg {...svgProps({ className, size })} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M15 3h3a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3h-3" />
      <path d="M10 17l5-5-5-5" />
      <path d="M15 12H3" />
    </svg>
  );
}

export function BrandUserPlus({ className, size }: IconProps) {
  return (
    <svg {...svgProps({ className, size })} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="8" r="4" />
      <path d="M2 20a7 7 0 0 1 14 0" />
      <path d="M20 8v6M23 11h-6" />
    </svg>
  );
}

export function BrandMessage({ className, size }: IconProps) {
  return (
    <svg {...svgProps({ className, size })} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a3 3 0 0 1-3 3H8l-5 4v-4H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h13a3 3 0 0 1 3 3v8Z" />
    </svg>
  );
}

export function BrandMenu({ className, size }: IconProps) {
  return <BrandList className={className} size={size} />;
}

export function BrandClose({ className, size }: IconProps) {
  return (
    <svg {...svgProps({ className, size })} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 5l14 14M19 5L5 19" />
    </svg>
  );
}

export function BrandPlus({ className, size }: IconProps) {
  return (
    <svg {...svgProps({ className, size })} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 5v14M5 12h14" />
    </svg>
  );
}

export function BrandTrophy({ className, size }: IconProps) {
  return (
    <svg {...svgProps({ className, size })} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
      <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
      <path d="M4 22h16" />
      <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
      <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
      <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
    </svg>
  );
}

